import type { GameplayState } from "../game/stores/useGameplayStore";
import { ARIADNE_MODEL, type Reveal } from "./seat";

/** The store fields her reveal sets, merged into the same update as the player's action (spec D2). */
export function herState(
  reveal: Reveal | null,
  fallback: string[],
): Partial<GameplayState> {
  if (!reveal) return { aiPath: fallback };
  return {
    aiPath: reveal.thread,
    aiModel: ARIADNE_MODEL,
    ariadneStatus: reveal.status,
  };
}
